import type { SVGProps } from "react";
export interface CheeseIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CheeseIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CheeseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15 19.128a.62.62 0 0 0-.125.372l.013.126a.6.6 0 0 0 .111.244zm1 .742a.6.6 0 0 0 .113-.244l.012-.126-.012-.125a.6.6 0 0 0-.113-.247zm-9-3.742a.62.62 0 0 0-.125.372l.012.126A.6.6 0 0 0 7 16.87zm1 .742a.6.6 0 0 0 .112-.244l.013-.126-.013-.125A.6.6 0 0 0 8 16.128zm8-6.742a.62.62 0 0 0-.124.372l.011.126a.6.6 0 0 0 .113.244zm1 .742a.6.6 0 0 0 .112-.244l.013-.126-.013-.126a.6.6 0 0 0-.111-.246zm-6.5-4.241a.62.62 0 0 0-.125.37l.013.126a.6.6 0 0 0 .111.245v-.74Zm1 .741a.6.6 0 0 0 .113-.245L11.624 7l-.011-.126a.6.6 0 0 0-.113-.244zm5.625 12.13a1.625 1.625 0 0 1-3.242.166l-.008-.166.008-.167a1.626 1.626 0 0 1 1.618-1.458l.165.008c.82.083 1.459.776 1.459 1.617m-8-3a1.626 1.626 0 0 1-3.241.166l-.009-.166.009-.167A1.625 1.625 0 0 1 7.5 14.875l.167.008A1.626 1.626 0 0 1 9.125 16.5m9-6a1.626 1.626 0 0 1-3.241.166l-.009-.166.009-.167A1.625 1.625 0 0 1 16.5 8.874l.166.01c.82.083 1.46.775 1.46 1.616Zm-5.5-3.5a1.626 1.626 0 0 1-3.242.166L9.375 7l.008-.165a1.626 1.626 0 0 1 1.618-1.459l.165.009c.82.083 1.459.774 1.459 1.615"
      />
      <path
        fill={color}
        d="M20.875 13.126H3.125V19l.018.177a.876.876 0 0 0 .857.698h16a.875.875 0 0 0 .875-.875zm-5.898-8.971c-.116-.05-.304-.055-.511.064l-.09.059-8.953 6.598h15.329c-.246-1.164-.85-2.364-1.711-3.468-1.138-1.458-2.637-2.637-4.064-3.253M23.125 19A3.125 3.125 0 0 1 20 22.125H4A3.126 3.126 0 0 1 .875 19v-6l.01-.217.006-.037a3.12 3.12 0 0 1 1.255-2.251l10.896-8.028.297-.193c.724-.416 1.65-.564 2.53-.185 1.816.784 3.605 2.218 4.945 3.936 1.336 1.712 2.31 3.82 2.31 5.976V19Z"
      />
    </svg>
  );
}
